import { useEffect } from "react";
import CustomTab from "../../components/ui/CustomTab";
import { pushRoute, setSaveDashboardFormState } from "../../store/globalSlice";
import { useDispatch } from "react-redux";

const tabs = [
	{
		label: "Scenario Setup",
		to: "scenario",
		value: "/setup/scenario",
	},
	{
		label: "Customer Group Setup",
		to: "customer-group",
		value: "/setup/customer-group",
	},
];

const Setup = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSaveDashboardFormState(false));
    dispatch(pushRoute("setup"));
  }, []);
	return <CustomTab tabs={tabs} />;
};

export default Setup;
